module.exports = __webpack_public_path__ + "media/images/Golden_Door_Logo-052179be66677e142e66c4d5dcff9f78.png";